// Event Readiness feature flag.
//
// Default: enabled. Mirror of communicationsHubFlag.js for consistency.
// Can be disabled per-browser via:
//   localStorage.setItem('cv80_event_readiness_enabled', 'false')
// or per-deployment via:
//   REACT_APP_EVENT_READINESS_ENABLED=false
//
// Per-event opt-in/default-on logic (new events default-on, existing events
// opt-in) is handled in later phases when there's actual event-scoped state
// to gate. Phase 0 just controls global visibility of the nav item + route.

const TRUE_VALUES = new Set(['1', 'true', 'yes', 'on']);
const FALSE_VALUES = new Set(['0', 'false', 'no', 'off']);

export function isEventReadinessEnabled() {
  const envValue = process.env.REACT_APP_EVENT_READINESS_ENABLED;
  const envStr = String(envValue || '').trim().toLowerCase();

  if (FALSE_VALUES.has(envStr)) return false;
  if (TRUE_VALUES.has(envStr)) return true;

  if (typeof window === 'undefined') {
    return true; // default-on
  }

  try {
    const stored = String(window.localStorage.getItem('cv80_event_readiness_enabled') || '').trim().toLowerCase();
    if (FALSE_VALUES.has(stored)) return false;
    if (TRUE_VALUES.has(stored)) return true;
    return true; // default-on
  } catch {
    return true;
  }
}
